import * as React from 'react';

import { Heading } from '../../../../../../../../components';
import iconPhotoBlank from '../../../../../../../../../assets/illustrations/ilustracion_foto.svg';
import {
  BlockPhoto,
  ButtonCancel,
  ButtonContainerNoFoto,
  ButtonRequest,
  CommonBlock
} from './styled';

interface UnregisteredPhotoProps {
  handleClick: () => void;
  handleClose: () => void;
}
const UnregisteredPhoto: React.FC<UnregisteredPhotoProps> = (props) => {
  const { handleClick, handleClose } = props;
  return (
    <CommonBlock>
      <BlockPhoto>
        <img src={iconPhotoBlank} alt="error" />
      </BlockPhoto>
      <Heading
        text="No tienes una foto registrada o validada"
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <ButtonContainerNoFoto>
        <ButtonRequest onClick={() => handleClick()}>
          <p>Ir a registrar foto</p>
        </ButtonRequest>
        <ButtonCancel onClick={() => handleClose()}>
          <p>Lo haré después</p>
        </ButtonCancel>
      </ButtonContainerNoFoto>
    </CommonBlock>
  );
};

export default UnregisteredPhoto;
